import { postMessageToParent } from './infrastructure.js';
export function postIframeAppHeight(height, unit = 'px') {
    const data = {
        app: {
            height,
            unit,
        },
    };
    postMessageToParent(data);
}
export function postIframeAppMinHeight(minHeightCalc) {
    const data = {
        app: {
            minHeightCalc,
        },
    };
    postMessageToParent(data);
}
export function postGenericMessage(data, sameIframe) {
    postMessageToParent(data, sameIframe);
}
export function postRoutingMessage(navOptions) {
    postMessageToParent({
        routing: navOptions,
    });
}
export function postAnalyticsMessage({ analyticsFct = 'trackEvent', eventName, payload }) {
    postMessageToParent({
        analyticsFct,
        eventName,
        payload,
    });
}
//# sourceMappingURL=messages.js.map